import './all-blocks.js';
import './theme.scss';

if (window && window.wp && window.wp.editor) {
    (async function () {
        const outlined = await import('./formats/outlined');
        outlined.default();
    })();
}
